import React from 'react';
import Script from 'next/script';

export default (
	<Script
		src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=MvXF9E"
		strategy="lazyOnload"
	/>
);
